import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NecRegionComponent } from './nec-region/nec-region.component';
import { NecBaseVoltageComponent } from './nec-base-voltage/nec-base-voltage.component';
import { NecDistrictComponent } from './nec-district/nec-district.component';
import { ActivatedRoute, Router } from '@angular/router';
import { NecSubstationComponent } from './nec-substation/nec-substation.component';
import { NecAcLineSegmentComponent } from './nec-ac-line-segment/nec-ac-line-segment.component';
import { NecPowerTransformerComponent } from './nec-power-transformer/nec-power-transformer.component';
import { NecConnectorSwitchContainerComponent } from './nec-connector-switch/nec-connector-switch-container/nec-connector-switch-container.component';
import { AcLineSegmentType } from '../../models/ac-line-segment.model';
import { NecTransformerRatingComponent } from './nec-transformer-rating/nec-transformer-rating.component';
import { PermissionsService } from '../../services/permissions.service';
import { SelectedSubstationForSchematic } from './nec-modals/nec-add-new-instance-equipment/nec-add-new-instance-equipment.component';

@Component({
  selector: 'lib-network-entity-classes',
  templateUrl: './network-entity-classes.component.html',
  styleUrl: './network-entity-classes.component.scss',
  standalone: false,
})
export class NetworkEntityClassesComponent implements OnInit {
  @ViewChild(NecRegionComponent) necRegionComponent!: NecRegionComponent;
  @ViewChild(NecDistrictComponent) necDistrictComponent!: NecDistrictComponent;
  @ViewChild(NecBaseVoltageComponent)
  necBaseVoltageComponent!: NecBaseVoltageComponent;
  @ViewChild(NecSubstationComponent)
  necSubstationComponent!: NecSubstationComponent;
  @ViewChild(NecAcLineSegmentComponent)
  necAcLineSegmentComponent!: NecAcLineSegmentComponent;
  @ViewChild(NecPowerTransformerComponent)
  necPowerTransformerComponent!: NecPowerTransformerComponent;
  @ViewChild(NecConnectorSwitchContainerComponent)
  necConnectorSwitchContainerComponent!: NecConnectorSwitchContainerComponent;
  @ViewChild(NecTransformerRatingComponent)
  necTransformerRatingComponent!: NecTransformerRatingComponent;

  showFeederBandUpdate: boolean = false;
  showFeederReassignment: boolean = false;

  items = [
    { id: 0, name: 'Substation', implented: true },
    { id: 1, name: 'AC Line Segment', implented: true },
    { id: 2, name: 'Power Transformers', implented: true },
    { id: 3, name: 'Connector', implented: true },
    { id: 4, name: 'Switch', implented: true },
    { id: 18, name: 'Grounding & Sectioning', implented: true },
    { id: 19, name: 'Protection Devices', implented: true },
    { id: 20, name: 'Compensation Equipment', implented: true },
    { id: 5, name: 'Base Voltage', implented: true },
    { id: 6, name: 'District', implented: true },
    { id: 7, name: 'Region', implented: true },
    { id: 8, name: 'Tariff', implented: false },
    { id: 9, name: 'Meter Type', implented: false },
    { id: 10, name: 'Transformer Rating', implented: true },
    { id: 11, name: 'Asset Status', implented: false },
    { id: 12, name: 'Account Status', implented: false },
    { id: 13, name: 'Customer Accounts', implented: false },
    { id: 14, name: 'DT Meter Type', implented: false },
    { id: 15, name: 'SLT Status', implented: false },
    { id: 16, name: 'Meter Price', implented: false },
    { id: 17, name: 'Billing Accounts', implented: false },
  ];

  editModal: number = 0;
  isIncomer: boolean = false;
  activeItemId = 0;
  quickActionMenuOpened: boolean = false;
  pendingSubstationToOpen: SelectedSubstationForSchematic | null = null;
  constructor(
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private router: Router,
    public permissionsService: PermissionsService,
  ) {}

  ngOnInit(): void {
    this.getActiveItemByUrlId();
    this.checkFeederBands();
    this.checkFeederReassignment();
    if ([3, 4, 18, 19, 20].includes(this.activeItemId)) this.editModal = 3;
    else this.editModal = this.activeItemId;
  }

  setActive(id: number) {
    const selectedItem = this.items.find((item) => item.id === id);

    if (selectedItem && !selectedItem.implented) {
      this.notImplemented();
      return;
    }

    this.activeItemId = id;

    this.router.navigate(['../', id], {
      relativeTo: this.route,
    });

    this.checkFeederBands();
    this.checkFeederReassignment();
  }

  onDownload() {
    if (this.activeItemId === 0 && this.necSubstationComponent) {
      this.necSubstationComponent.download();
    } else if (this.activeItemId === 1 && this.necAcLineSegmentComponent) {
      this.necAcLineSegmentComponent.download();
    } else if (this.activeItemId === 2 && this.necPowerTransformerComponent) {
      this.necPowerTransformerComponent.download();
    }

    this.quickActionMenuOpened = false;
  }

  onUpload() {
    if (this.activeItemId === 0 && this.necSubstationComponent) {
      this.necSubstationComponent.openUploadModal();
    } else if (this.activeItemId === 1 && this.necAcLineSegmentComponent) {
      this.necAcLineSegmentComponent.openUploadModal();
    } else if (this.activeItemId === 2 && this.necPowerTransformerComponent) {
      this.necPowerTransformerComponent.openUploadModal();
    }

    this.quickActionMenuOpened = false;
  }

  onUpdate() {
    if (this.activeItemId === 0 && this.necSubstationComponent) {
      this.necSubstationComponent.openUpdateModal();
    } else if (this.activeItemId === 1 && this.necAcLineSegmentComponent) {
      this.necAcLineSegmentComponent.openUpdateModal();
    }
    this.quickActionMenuOpened = false;
  }

  onFeederBandUpload() {
    this.necAcLineSegmentComponent.openUploadModal(true);

    this.quickActionMenuOpened = false;
  }

  onFeederReassignment() {
    this.necSubstationComponent.openUploadModal(true);

    this.quickActionMenuOpened = false;
  }

  onAddNewClicked() {
    if (this.activeItemId === 5 && this.necBaseVoltageComponent) {
      this.necBaseVoltageComponent.openCreateModal();
    }
    if (this.activeItemId === 6 && this.necDistrictComponent) {
      this.necDistrictComponent.openAddModal();
    }
    if (this.activeItemId === 7 && this.necRegionComponent) {
      this.necRegionComponent.openAddModal();
    }
    if (this.activeItemId === 0 && this.necSubstationComponent) {
      this.necSubstationComponent.openAddModal();
    }
    if (this.activeItemId === 2 && this.necPowerTransformerComponent) {
      this.necPowerTransformerComponent.openAddModal();
    }

    if (this.activeItemId === 1 && this.necAcLineSegmentComponent) {
      if (
        this.necAcLineSegmentComponent.selectedTab != AcLineSegmentType.Incomer
      )
        this.necAcLineSegmentComponent.openAddModal();
      else {
        this.necAcLineSegmentComponent.openAddIncomerModal();
      }
    }
    if (
      (this.activeItemId === 3 ||
        this.activeItemId === 4 ||
        this.activeItemId === 18 ||
        this.activeItemId === 19 ||
        this.activeItemId === 20) &&
      this.necConnectorSwitchContainerComponent
    ) {
      this.necConnectorSwitchContainerComponent.openAddModal();
    }
    if (this.activeItemId === 10 && this.necTransformerRatingComponent) {
      this.necTransformerRatingComponent.openAddModal();
    }
  }

  // On equipment tabs "Add New Instance" leads into editing the substation schematic.
  get canAddNewInstance(): boolean {
    if (![2, 3, 4, 18, 19, 20].includes(this.activeItemId)) return true;
    return this.permissionsService.isSchematicDiagramViewAllowed && this.permissionsService.isSchematicDiagramCreateEditAllowed;
  }

  notImplemented() {
    this.toastr.info('Not implemented yet!');
  }

  onOpenSubstationSchematic(selected: SelectedSubstationForSchematic) {
    this.pendingSubstationToOpen = selected;
    this.setActive(0);
  }

  onPendingSubstationHandled() {
    // Deferred: NecSubstationComponent emits this synchronously from its own ngOnInit,
    // which runs mid change-detection pass. Clearing pendingSubstationToOpen immediately
    // would mutate a value Angular already checked in this same pass (NG0100).
    setTimeout(() => (this.pendingSubstationToOpen = null));
  }

  getActiveItemByUrlId() {
    const id = +this.route.snapshot.paramMap.get('id')!;
    switch (id) {
      case 0: {
        this.activeItemId = 0;
        break;
      }
      case 1: {
        this.activeItemId = 1;
        break;
      }
      case 2: {
        this.activeItemId = 2;
        break;
      }
      case 3: {
        this.activeItemId = 3;
        break;
      }
      case 4: {
        this.activeItemId = 4;
        break;
      }
      case 5: {
        this.activeItemId = 5;
        break;
      }
      case 6: {
        this.activeItemId = 6;
        break;
      }
      case 7: {
        this.activeItemId = 7;
        break;
      }
      case 10: {
        this.activeItemId = 10;
        break;
      }
      case 18: {
        this.activeItemId = 18;
        break;
      }
      case 19: {
        this.activeItemId = 19;
        break;
      }
      case 20: {
        this.activeItemId = 20;
        break;
      }
    }
  }

  handleEditModal(editModal: number) {
    this.editModal = editModal;
  }

  getModalTarget() {
    if ([2, 3, 4, 18, 19, 20].includes(this.activeItemId)) {
      return null;
    }
    return (
      '#editAddModal-' +
      (this.activeItemId == 1
        ? this.editModal
        : this.activeItemId)
    );
  }

  checkFeederBands() {
    this.showFeederBandUpdate =
      this.permissionsService.hasDashboardConfigFeederBands &&
      this.activeItemId === 1;
  }

  checkFeederReassignment() {
    this.showFeederReassignment = this.activeItemId === 0;
  }
}
